import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-financeiro-exame`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        datatable(queryParms) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
    }
}